<template>
  <div>
      <h1>Confirmation</h1>
      <p>Your slot are reserved, you'll receive a confirmation mail for your reservation dates</p>
      <ul>
        <li v-for="date in reservations" :key="date.id">  
          <div class="item">
            <span>{{ date.date}} {{date.start_hour}} {{date.end_hour}}</span>
          </div>
        </li>
      </ul> 
      <button class="btn primary" @click="$router.push('/')">Return to home</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed:{
    ...mapGetters("scheduler",["reservations"])
  },
  methods:{

  }
}
</script>

<style lang="less">
  #confirmDate{
    min-height: calc(100vh - 400px);
    width: 100%;
    background-color: #fff;
    padding-top: 50px;
    h1{
      font-size: 24px;
      color: #2F2B2B;
      margin-bottom: 50px;
      font-weight: 800;
    }
    ul{
      margin-top: 50px;
      margin-bottom: 50px;
      li{
        .item{
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
          svg{
            margin-right: 20px;
          }
        }
      }
    }    
  }
</style>